<template>
  <v-data-table
    :headers="headers"
    :items="notificacoes"
    :search="search"
    :loading="loading"
    item-key="idNotificacao"
    class="elevation-1 pa-5"
  >
    <template v-slot:item.actions="{item}">
      <v-btn small color="success" class="ml-2" @click="aprovarItem(item)">
        <v-icon>mdi-arrow-top-right</v-icon>
      </v-btn>
      <v-btn small color="error" class="ml-2" @click="deleteItem(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      loading: true,
      headers: [
        {
          text: 'Nome',
          align: 'left',
          sortable: true,
          value: 'CodAgroindustriaRelacionada',
          width: '1%',
        },
        {
          align: 'center',
          sortable: true,
          text: 'ID',
          value: 'CodConsultorRelacionado',
          width: '1%',
        },
        {text: 'Ações', value: 'actions', width: '1%', align: 'center'},
      ],
      notificacoes: [],
      identificadorAgroindustria: '',
    }
  },
  created() {
    var idAgro = localStorage.getItem('CodAgro')
    idAgro = idAgro.substring(1, idAgro.length - 1)
    this.identificadorAgroindustria = idAgro
    this.api('/relacionamento/verificarNotificacoes', {
      params: {
        codAgro: this.identificadorAgroindustria,
      },
    })
      .then(response => {
        this.notificacoes = response.data
        this.loading = false
      })
      .catch(e => {
        this.erros.push(e)
      })
  },
  methods: {
    deleteItem(item) {
      const index = this.notificacoes.indexOf(item)
      this.Swal.fire({
        title: 'Apagar Solicitação',
        text: 'Você tem certeza que deseja remover esta solicitação?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#4caf50',
        cancelButtonColor: '#ff5252',
        confirmButtonText: 'Sim, desejo removê-la!',
      }).then(result => {
        if (result.value) {
          // console.log(this.notificacoes[index].CodConsultorRelacionado)
          this.api.delete('/relacionamento/deletarNotificacao', {
            params: {
              idNotificacao: this.notificacoes[index].CodConsultorRelacionado,
            },
          })
          this.notificacoes.splice(index, 1)
          this.Swal.fire(
            'Removido!',
            'Esta agroindustria foi removida com sucesso!',
            'success',
          )
        } else {
          this.Swal.fire(
            'Erro',
            'Esta agroindustria não pode ser removida!',
            'error',
          )
        }
      })
    },

    aprovarItem(item) {
      const index = this.notificacoes.indexOf(item)
      this.Swal.fire({
        title: 'Aprovar Solicitação',
        text: 'Você tem certeza que deseja aprovar esta solicitação?',
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: '#4caf50',
        cancelButtonColor: '#ff5252',
        confirmButtonText: 'Sim, desejo aprova-la!',
      }).then(result => {
        if (result.value) {
          const idReq = this.notificacoes[index].CodConsultorRelacionado
          this.api.put(
            '/relacionamento/attNotificacao',
            {idRelacionamento: idReq},
            {headers: {'Content-Type': 'application/json'}},
          )
          this.notificacoes.splice(index, 1)
          this.Swal.fire(
            'Aprovado!',
            'Este consultor foi aprovado com sucesso!',
            'success',
          )
        } else {
          this.Swal.fire(
            'Erro',
            'Este consultor não pode ser removido!',
            'error',
          )
        }
      })
    },
  },
}
</script>
